import {DoorOpen} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'rooms',
    children: [
      {
        path: '',
        loader: protectedLoader('ROOMS', 'VIEW_ROOMS'),
        async lazy() {
          const {RoomListPage} = await import('./pages/RoomListPage');
          return {
            element: <RoomListPage />,
          };
        },
        children: [
          {
            path: 'add',
            loader: protectedLoader('ROOMS', 'CREATE_ROOM'),
            async lazy() {
              const {AddRoomPage} = await import('./pages/AddRoomPage');
              return {
                element: <AddRoomPage />,
              };
            },
          },
          {
            path: ':id',
            loader: protectedLoader('ROOMS', 'UPDATE_ROOM'),
            async lazy() {
              const {EditRoomPage} = await import('./pages/EditRoomPage');
              return {
                element: <EditRoomPage />,
              };
            },
          },
        ],
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/rooms',
    text: i18n.t('Rooms'),
    icon: <DoorOpen />,
    permission: 'VIEW_ROOMS',
    entitlement: 'ROOMS',
  },
] as MenuItemElement[];
